export const removeEmptyKeys = (obj: any) => {
  return Object.entries(obj || {}).reduce((acc, [key, value]) => {
    if (value) {
      acc[key as keyof any] = value;
    }
    return acc;
  }, {} as any);
};
